import { render, staticRenderFns } from "./ProductOptionItem.vue?vue&type=template&id=fe24dfe8&scoped=true&"
import script from "./ProductOptionItem.vue?vue&type=script&lang=js&"
export * from "./ProductOptionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionItem.vue?vue&type=style&index=0&id=fe24dfe8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe24dfe8",
  null
  
)

export default component.exports